export default {
sets: `Komplektid`,
stats: `Statistika`,
discover: `Avastama`,
guides: `Giidid`,
settings: `Sätted`,
unsupportedBrowserBody: `Flashcards seda brauserit ei toeta. Laadige alla Chrome'i või Opera uusim versioon või laadige alla meie iPhone'i või Androidi rakendus`,
unsupportedBrowserTitle: `Toetamata brauser`,
noData: `Andmeid ei kuvata`,
contactUsTitle: `Me armastame kuulda, kuidas meie kasutajad meie rakendust kasutavad ja kuidas saaksime paremaks muuta. Viska meile sõnum mis tahes päringutega, näiteks funktsioonitaotluste või veateadetega`,
rateAppStore: `Määr AppStore'is`,
rateGoogle: `Hinda Google Plays`,
close: `Sulge`,
shareFriends: `Jagage sõpradega`,
noCardsQ: `Kas teil pole välkkaarte?`,
noCardsS: `Valige alustamiseks meie kollektsiooni hulgast`,
suggestSet: `Soovitage komplekt`,
createOwn: `Looge oma`,
search: `Otsing`,
loading: `Laadimine`,
words: `Sõnad`,
downloads: `Allalaadimine`,
export: `Ekspordi-`,
import: `Import`,
importing: `Importimine ... ärge sulgege rakendust`,
importPreview: `Impordi eelvaade`,
howQuizlet: `Kuidas importida Quizlet`,
cards: `Kaardid`,
importPreviewStatus: `__ Tingimused on olemasolevatele ___ -kaartidele lisamiseks valmis`,
importPaste: `Kleepige oma kaardid ülaltoodud Textreasse`,
setTotalLimitReached: `Studytis võib olla ainult 3000 kaarti`,
studying: `Õppimine`,
learnt: `Õpitud`,
mastered: `Omandatud`,
new: `Uus`,
noTerm: `Pole tähtaega`,
noDef: `Definitsiooni pole`,
cardSaved: `Kaart salvestatud`,
reviews: `Ülevaated`,
practices: `Tavad`,
flashcards: `Välklambid`,
alerts: `Teated`,
corrects: `Parandab`,
mistakes: `Vead`,
reviewCycle: `Ülevaatetsükkel`,
reviewsLeft: `Arvustused on jäänud`,
lastReview: `Viimane ülevaade`,
nextReview: `Järgmine ülevaade`,
hideHistory: `Peida täielik ajalugu`,
showHistory: `Näidata täielikku ajalugu`,
strength: `Tugevus`,
star: `Staar`,
image: `Pilt`,
tag: `Silt`,
added: `lisatud`,
removed: `eemaldatud`,
reviewedFrom: `Vaadatud __ -st`,
notifications: `Teatised`,
reviewedPractice: `Vaadatud __ järgi ___ praktika järgi`,
successfully: `edukalt`,
unsuccessfully: `edutult`,
termUpdated: `Tähtaeg värskendatud`,
defUpdated: `Määratlus värskendatud`,
flashcardCreated: `Flash -kaart loodud`,
dropboxImage: `Piltide lisamiseks peate lubama Dropboxi sünkroonimise`,
deleteImgConfirm: `Kas olete kindel, et soovite selle pildi kustutada?`,
uploading: `Üleslaadimine`,
save: `Kokkuhoid`,
uploadImageFail: `Pilti üleslaadimine ebaõnnestus`,
imageUploaded: `Pilt üles laaditud`,
setNotFound: `Studyset ei leitud!`,
notEnoughCards: `Pole piisavalt kaarte!`,
of: `__ ___`,
on: `Peal`,
off: `Väljas`,
auto: `Automaatne`,
manual: `Käsiraamat`,
pronounce: `Hääldama`,
practiceCompleted: `Olete selle praktika lõpetanud`,
closePractice: `Tihe praktika`,
autoplay: `Automaatne mäng`,
secFlipSecNext: `__ Sec Flip, ___ sec Järgmine`,
autopronounce: `Autopronocence`,
onlyTerm: `Ainult tähtaeg`,
onlyDef: `Ainult määratlus`,
termAndDef: `Tähtaeg ja määratlus`,
savePractice: `Säästa praktikat?`,
continueLater: `Jätkake hiljem`,
deletePractice: `Praktika kustutamine`,
term: `Tähtaeg`,
def: `Määratlus`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Ülevaateesmärk`,
dailyGoal: `Igapäevane eesmärk`,
edit: `Redigeerima`,
setUp: `Püstitama`,
noRecentPractice: `Teil pole hiljutisi tavasid`,
continueLastReview: `Jätkake viimast ülevaadet`,
dueCards: `Tähtaeg`,
studyNow: `Uurige kohe`,
newCards: `Uued kaardid`,
terms: `tingimused`,
defs: `definitsioonid`,
validCardsOf: `Ainult __ valitud ___ -kaartidest saab harjutada, kuna teistel puudub termin või määratlus`,
reviewCards: `Ülevaatekaardid`,
customizePractice: `Kohandada praktikat`,
next: `Järgmine`,
iWasRight: `mul oli õigus`,
printProAlert: `Palun ostke Pro tellimus, et printida rohkem kui 20 välklampi`,
print: `Trükk`,
printWidth: `Tähtajaline laius`,
printFont: `Fondi suurus`,
printBorder: `Piir`,
printMargin: `Lehesirge`,
printPadding: `Sõnapolster`,
preparingFile: `Faili ettevalmistamine`,
notificationsBlocked: `Teatised pole lubatud, lubate telefoni seadetest teatised`,
ranOutOfWords: `Sai kaardid otsa, taaskäivitage praktika, et alustada üle`,
ranOutOfWordsShort: `Sõnadest otsa saama`,
ranOutOfWordsBody: `Uute sõnade ajastamiseks avage rakendus`,
proIncreaseNotifications: `Premium -versioonis saate suurendada koguteateid 10–50 -ni.`,
schedule: `Ajakava`,
frequency: `Sagedus`,
mode: `Režiim`,
tM1: `1 minut`,
tM2: `2 minutit`,
tM5: `5 minutit`,
tM10: `10 minutit`,
tM15: `15 minutit`,
tM30: `30 minutit`,
tH1: `1 tund`,
tH2: `2 tundi`,
termPassive: `Passiivne tähtaeg`,
termActive: `Aktiivne`,
defPassive: `Passiivne`,
defActive: `Aktiivne`,
scheduledIn: `Kavandatud __ minuti pärast`,
scheduledAlertsProT: `Suurendage Pro -ga plaanipäraseid hoiatusi`,
scheduledAlertsProB: `Propaketiga saate kavandatud teateid 10–50 suurendada`,
seeFeatures: `Vaata funktsioone`,
defAndTerm: `Määratlus ja mõiste`,
termHoldDef: `Mõistus, pidage määratluse paljastamiseks`,
defHoldTerm: `Määratlus, pidage meeleavaldust`,
notificationType: `Teatise tüüp`,
copyToClipboard: `Kopeerida lõikelauale`,
enterAuthCode: `Sisestage oma autoriseerimiskood`,
invalidCode: `Kehtetu kood on ette nähtud`,
copied: `Kopeeritud!`,
promoH2: `Flashcard Manager Pro`,
promoP: `Puudutage, et avastada kõik esmaklassilised funktsioonid, et oma tempos tõhusamalt õppida`,
promoBtn: `Avastage kõik omadused`,
setDropboxH2: `Dropboxi sünkroonimine`,
setDropboxPOff: `Luba DropBox Sync, et hoida oma komplekte, välkkaarte, silte ja edusamme kõigi teie seadmete varundamisel ja värskendamisel.`,
setDropboxPOn: `Teie andmed on varundatud ja sünkroonitud teie seadmetes.`,
setDropboxBtn: `Sünkroonima`,
status: `Olek`,
syncNow: `Sünkroonis kohe`,
contact: `Kontakt`,
contactUs: `Võta meiega ühendust`,
useFromBrowser: `Kasutage brauserist`,
useFromBrowserMsg: `Külastage oma arvutis flashcardsmadesimple.com ja taastage oma kaardid ja litsents, lubades Dropboxi sünkroonis`,
termsPrivacy: `Tingimused ja privaatsus`,
dailyReviewGoal: `Igapäevane ülevaateesmärk`,
numberTerms: `Tingimuste arv`,
selectTerm: `Valige tähtajaga vihjega`,
selectDef: `Valige määratluse vihjega`,
pronounceTerm: `Hääldake tähtajaga vihjet`,
pronounceDef: `Hääldage määratluse vihjega`,
typeTerm: `Tüüp tähtajaga vihje`,
typeDef: `Tüüp määratluse vihjega`,
quizTypes: `Eelistatud viktoriini tüübid`,
spacedRepetition: `Asetatud kordusgraafik`,
spacedRepetitionP: `Spageeritud kordus võimaldab teil sõnad väiksemate jõupingutustega omandada, vahetades arvustusaega järk -järgult välja. Vaikegraafik on 1-3-7-15-31 päeva, kuid saate seadistada ka koha.`,
spacedRepetionScheduleItem: `__ päevad pärast ___ ülevaadet (päev ____)`,
atLeastOneSchedule: `Vaja on vähemalt ühte ajakava`,
revisionLimitReached: `Jõudsite maksimaalse pöördearvuni`,
addReviewSchedule: `Lisage uus ülevaate ajakava`,
autoMarkLearnt: `Auto Mark õppis pärast`,
autoMarkMastered: `Automärk meisterdas pärast`,
tagManager: `Sildijuht`,
delete: `Kustutama`,
addTag: `Lisage uus silt`,
tagDeletionH: `Sildi kustutamine`,
tagDeletionP: `Kas olete kindel, et soovite selle sildi kustutada?`,
cancel: `Tühistama`,
daysAfterLastReview: `Päevad pärast viimast ülevaadet`,
linkDropbox: `Link Dropbox`,
startSync: `Alustage sünkroonimist`,
starred: `Peaosa`,
images: `Pildid`,
tags: `Sildid`,
types: `Tüübid`,
activeDays: `Aktiivsed päevad`,
inactiveDays: `Passiivsed päevad`,
longestStreak: `Pikim vööt`,
dailyGoalsCompleted: `Igapäevased eesmärgid on täidetud`,
dailyGoalsFailed: `Igapäevased eesmärgid ebaõnnestusid`,
typePairs: `Tüübipaarid`,
reviewTypes: `Ülevaatetüübid`,
typePractice: `Tüüpi praktika`,
pronouncePractice: `Hääldamine praktika`,
selectPractice: `Valige praktika`,
notificationReview: `Teavitusülevaade`,
flashcardReview: `Välklambi ülevaade`,
studyset: `Studyset`,
enterStudysetName: `Sisestage oma Studyti nimi`,
studysetName: `Sisestage komplekti nimi`,
termType: `Terminitüüp / Lang`,
defType: `Definitsiooni tüüp / Lang`,
exportCards: `Ekspordikaardid`,
importCards: `Impordikaardid`,
quiz: `Viktoriin`,
showingOutOfCards: `Näita __ ___ kaartidest`,
showingAllCards: `Kõigi kaartide kuvamine, tippige ülaltoodud otsinguribale või koputage filtreerimiseks mis tahes silte`,
recording: `Salvestus`,
downloadSet: `Lisage minu komplektidele`,
addNewCard: `Lisage uus kaart`,
saveStudyset: `Salvesta õppekomplekt`,
studysetDeletionH: `StudySet kustutamine`,
studysetDeletionP: `Kas olete kindel, et soovite selle Studyset kustutada, see kustutab ka kõik sisalduvad kaardid.`,
cardDeletionH: `Kaardi kustutamine`,
cardDeletionP: `Kas olete kindel, et soovite selle kaardi kustutada`,
cardLimitReached: `Studytis võib olla ainult 3000 kaarti`,
limitExceeded: `Piirangu ületatud`,
atLeastTenCards: `Lisage tavadega alustamiseks vähemalt 10 kaarti`,
searchInAll: `Otsige kõigis uuringukomplektides`,
noMatch: `Pole matš`,
atLeastThreeChars: `Sisestage otsimiseks vähemalt 3 tähemärki`,
noSets: `Komplekte pole`,
startingSync: `Sünkroonimine`,
noSetsP: `Valige alustamiseks allpool toodud suvandite hulgast`,
startingSyncP: `Saame teie andmed Dropboxist, see võib võtta natuke aega`,
createNewStudyset: `Looge uus Studyset`,
restoreFromBackup: `Taastage varufailist`,
setStarterPacks: `StudySet starterpacks`,
selectPracticeType: `Valige harjutamise tüüp`,
noDueCards: `Pole veel täitumismärke, välkkaardid, mille olete varem üle vaadanud`,
noNewCards: `Uusi kaarte õppimiseks pole`,
subscriptionH: `Osta Pro, et nautida kõiki funktsioone ja toetada pidevat arengut.`,
buyLifetimePro: `Osta eluaegne pro __`,
restorePurchase: `Ostu taastamine`,
termsPrivacyC: `Tingimused ja privaatsuseeskirjad`,
licenceShare: `Kui ostsite litsentsi teisest seadmest`,
enterTagName: `Sisestage sildi nimi`,
invalidName: `Kehtetu nimi`,
create: `Looma`,
name: `Nimetus`,
tagName: `Teie sildi nimi`,
color: `Värvus`,
back: `tagasi`,
rowSeparator: `Rea eraldaja`,
termDefSeparator: `Termin - deferaator`,
output: `Väljund`,
inputCards: `Sisendkaardid`,
review: `Ülevaade`,
language: `Keel`,
archiveReversible: `Arhiiv (seadetest pöörduv)`,
deletePermanent: `Kustuta (pöördumatu)`,
archivedCards: `Arhiveeritud kaardid`,
masteredCards: `Meisterdatud kaardid`,
due: `Makstud`,
reviewed: `Üle vaadatud`,
markReviewed: `Mark vaadati üle`,
markMastered: `Mark meisterdas`,
forXYCards: `__ ___ kaartide jaoks`,
createdAtSortBy: `Loomise kuupäev`,
lastReviewedSortBy: `Viimane ülevaatuse kuupäev`,
reviewCountSortBy: `Arvustuste arv`,
strengthSortBy: `Tugevus`,
termSortBy: `Tähestikuline termin`,
definitionSortBy: `Tähestikuline def.`,
ascSortBy: `Tõusv`,
descSortBy: `Laskuv`,
featureSync: `Õppige kõike, igal pool ja igal ajal, kui oma välkkaardid on sünkroonitud kõigi teie seadmete kaudu`,
featureSpacedrepetition: `Uurige oma üldist edusamme ja pöörduge tagasi harjutamiseks, mida peate harjutama`,
featureNotifications: `Laadige oma õppimine ilma paindlike teatistega rakendust avamata`,
featureFlashcards: `Autoplay Flashcards, kui teie käed või silmad on hõivatud, kuid teil on siiski kasutamata tähelepanu`,
featureQuiz: `Sobitada, kirjutada välja, kuulata või valida oma välklambrite harjutamiseks`,
featureStats: `Saage parem ülevaade oma kaartidest ja tulemustest ning otsige kõigist oma välklambi komplektidest`,
featureImport: `Me ei salvesta kunagi teie kohta andmeid ja saate kõiki oma andmeid hõlpsalt eksportida ja importida`,
featurePrint: `Saage natuke õppimist, printides oma välkkaardid ja DIY oma õppimisplatvorm`,
splashIntro: `Uurige kõiki oma välkkaarte kõikjal oma tempos ja stiilis`,
selectSortOrder: `Sortimisjärjekord`,
selectSortProp: `Omandi sorteerima`,
applyFilters: `Rakendage filtreid`,
selectSetType: `Mida soovite harjutada?`,
getStarted: `Alustama`,
tapToUnarchive: `Puudutage kaarte, mida soovite mitte`,
untitled: `Pealkirjata`,
sortHintNew: `Näete kaarte, mis loodi kõige pikemalt tagasi`,
sortHintDue: `Näete kaarte, mille tähtaeg on kõige pikem`,
sortHintOther: `Näete kaarte, mida pole kõige pikemat uuritud`,
flashcardsWhen: `, kui teie käed või silmad on hõivatud, isegi muusika / netisaadete kuulamise ajal`,
notificationsWhen: `, sest kui olete väljas ja tahate lihtsalt kiireid õppimisbitte`,
quizWhen: `, sest kui saate õppimise eest täielikku tähelepanu pöörata, oma kaartide valdamiseks`,
features: `Funktsioonid`,
ratings: `Hinnangud`,
notificationDailyCatchUpBody: `Uus: __, tähtaeg: ___, õppimine: ____, õppinud: _____, meisterdatud: ______`,
notificationDailyCatchUpTitle: `Igapäevane püüdmine`,
reviewedJN: `Üle vaadatud just nüüd`,
customUpdated: `Kohandatud tekst värskendatud`,
customTextField: `Sünonüümid, näited jne.`,
field: `Valdkond`,
link: `Link`,
backToParentCard: `Tagasi vanemakaardi juurde`,
discard: `Äraviskamine`,
failedImageLoad: `Pilti laadimine ebaõnnestus, veenduge, et oleksite Interneti -ühenduses`,
printDIYLabel: `DIY omaenda loomingulise paberil põhineva uuringu seadistamine, jagage meiega oma loomingut ja saate rakenduses esile kajastada.`,
reviewGraphChart: `Ülevaatussagedus`,
langNotSet: `Keel pole paika pandud`,
pronouncationLangInfo: `Häälduse lubamiseks peate valima mõiste ja määratluskeele. Kõnerisilt ilmub keelte kõrvale, kui teie seade seda keelt toetab`,
clearFilters: `Selge filter`,
subFreeUnlimited: `Piiramatu studüsetid, välkkaardid, tavad, otsing ja sünkroonimine`,
customFields: `Kohandatud väljad`,
subLinks: `Kaardilingid`,
subPrint: `Prindi / Studyset`,
subNotifications: `Teatamine enne rakenduse avamist`,
subCardsStudysets: `Kaardid / Studyset`,
subRevisionCycles: `Kohandatud redaktsioonitsüklid`,
subscriptionHEnd: `PRO -le täiendamine näitab meile, et leiate meie raske töö väärtusliku ning julgustab meid ja kohvi uute hämmastavate asjade parandamiseks ja loomiseks.`,
subFree: `Vaba`,
subPro: `Pro`,
guideSpacedRepetition: `Kuidas asetsevad kordused toimivad ja praktikatüübid`,
guideSearch: `Otsimine ja filtreerimine`,
guideSync: `Luba varundamine ja sünkroonimine oma seadmetes`,
guidePronunciation: `Luba hääldus`,
guideImport: `Kaartide importimine väljuvatest allikatest`,
guideAccess: `Kellel on juurdepääs minu andmetele?`,
guideData: `Milliseid andmeid me kogume?`,
guideContact: `Kas vajate abi millegi muuga? Kirjutage meile`,
arrowStrength: `Seadke, kui hästi te seda kaarti teate`,
arrowImage: `Lisage pilte`,
arrowField: `Lisage täiendavad kohandatud tekstiväljad`,
arrowTag: `Manustage sildid`,
arrowStar: `Märk lemmik`,
arrowLink: `Link teiste kaartidega`,
arrowGoal: `Seadistage endale igapäevane ülevaateesmärk`,
arrowDue: `Uurimissõnad, mis tuleb üle vaadata`,
arrowNew: `Õppekaardid, mida pole veel üle vaadatud`,
arrowMastered: `Kui teil pole tähtaega ega uusi kaarte, saate nende meisterdamiseks üle vaadata meisterdatud kaardid`,
arrowImport: `Importige oma olemasolevad välkkaardid`,
arrowNewCard: `Lisage uued välkkaardid`,
dropboxStep1: `1. Hankige Dropboxist juurdepääsukood sisse logides`,
dropboxStep1Btn: `Logige sisse Dropboxiga`,
dropboxStep2: `2. Sisestage allpool juurdepääsukood`,
dropboxStep2Input: `Sisestage kood siit`,
dropboxStep3: `3. Alustage sünkroonimist`,
alreadyLinked: `Juba lingitud, koputage lahti ühendamiseks`,
selectCardsToLink: `Lingimiseks valige kaardid`,
unsupportedLangP: `Valige keel, mis toetab hääldamist komplekti seadetest`,
links: `Lingid`,
emailUs: `Saada meile e -kiri`,
whatsappUs: `Whatsapp meid`,
printMinHeight: `Min. rea kõrgus`,
exportType: `Ekspordi faili tüüp`,
generateFileText: `Genereerige fail`,
generatatingFile: `Genereerimisfail`,
verySmall: `Väga väike`,
small: `Väike`,
normal: `Normaalne`,
big: `Suur`,
veryBig: `Väga suur`,
repeatNTimes: `Korda __ korda`,
pause: `Paus`,
for: `jaoks`,
say: `Ütlema`,
defShort: `Defin.`,
times: `ajad`,
autoplayPreferences: `Seadke autoplayi eelistused`,
autoPlay1: `Paus pärast eelmist sõna`,
autoPlay2: `Tähtaegumise arv`,
autoPlay3: `Enne määratluse paljastamist paus`,
autoPlay4: `Määratluse arv hääldamise arv`,
autoPlay5: `Enne järgmise sõna kuvamist paus`,
autoPlay6: `Korrake sama välklambi`,
startAutoPlay: `Alustage automaati`,
autoPlayOffConfirm: `Lülitage automaatkäik välja, et lubada käsitsi juhtelemente`,
turnOff: `Lülita välja`,
keepPn: `Jätka`,
foundIn: `Leitud __`,
repeat: `kordama`,
stop: `Peatus`,
listenInBreak: `Kas sa teadsid? Muusikat / taskuhäälingusaateid saate vaheajal kuulata`,
contextSearch: `Kontekstiotsing`,
contextSearchText: `Hankige näiteid selle kohta, kuidas __ erinevates lausetes kasutati`,
transalteSearch: `Tõlkima`,
translateSearchText: `Tõlgi __ -ni ___`,
synonymSearch: `Sünonüümiotsing`,
synonymSearchText: `Otsige __ sünonüüme`,
selectToAdd: `Valige tulemused, mida soovite sellele kaardile lisada`,
addToCard: `Lisage kaardile valitud`,
hideFromPractice: `Varjama`,
setLanguageRequired: `Valige StudySeti üksikasjade terminite ja määratluste keel`,
fieldNeedsText: `Sisestage enne otsimist midagi sellesse välja`,
possibleDupe: `Võimalik duplikaat`,
loadNextXCards: `Laadige järgmine __ kaardid`,
repeatPractice: `Korda neid __ kaarte`,
keepScreenOnInfo: `Võimalik, et peate oma automaatse lukustuse seadet reguleerima, et ekraan automaatselt sisse lülitada.`,
siteLoginH2: `SFM -konto`,
siteLoginP: `Saate oma välkmälukaarte teha, et jagada oma välkkaarte oma sõprade, õpilaste või kogu kogukonnaga.`,
logOut: `Logi välja`,
logIn: `Logi sisse`,
createAccount: `Loo uus konto`,
signUp: `Registreeri`,
username: `Kasutajanimi`,
email: `E -kiri`,
password: `Parool`,
networkError: `Võrguviga`,
fillAllDetails: `Palun täitke kõik üksikasjad`,
noUserWithDetails: `Sisestatud üksikasjadega pole ühtegi kasutajat leidnud`,
userAlreadyExists: `Antud e -kiri või kasutajanimi on juba olemas`,
signUpOrLoginToCont: `Jätkamiseks registreeruge või logige sisse?`,
atLeastOneCardToShare: `Jagamiseks on vaja vähemalt üks kaart`,
publishingStudyset: `Kirjastus Studyt`,
updatesDetected: `Avastatud värskendused, kas soovite jätkata kohalike andmete värskendamist? (Kustutatud: __, värskendatud: ___, uus: ____)`,
updatesApplied: `Rakendatud värskendused`,
alreadyUpToDate: `Juba ajakohane`,
practiceTypeArrow: `Avastage erinevad praktika viisid`,
share: `Osa`,
sharingModalIntro: `Jagage selles komplektis oma välklambreid oma sõprade, õpilaste või kogu kogukonnaga.`,
whatIsShared: `Mida jagatakse`,
whatIsNotShared: `Mida ei jagata`,
whatIsSharedText: `Seadke nimi, määrake terminikeel, kindel keel, kõik komplektis olevad kaardid, määratlused, kohandatud tekstiväljad ja pildid`,
whatIsNotSharedText: `Kõik kaardi tugevused, tähed, lingid, sildid ja teie arvustusajalugu`,
checkForSharedUpdates: `Kontrollige looja värskendusi`,
fetchUpdates: `Tõmba värskendusi`,
youSharedStudyset: `Jagasite seda Studyset`,
publishChanges: `Salvesta ja avaldada muudatusi`,
redeem: `Lunastama`,
noAds: `Reklaame pole`,
dupeDetection: `Duplikaat tuvastamine`,
coffeeFeature: `Kohv, et aidata meil välja töötada rohkem funktsioone`,
shareLink: `Jaga linki`,
coffeeForUs: `Saate eluaegse litsentsi ainult __ eest, mis annab Emily 6 kohvi, Dominiku 3 kohvi ja Russ 3 kohvi, mis õhutab meid umbes 39 tundi, et see rakendusüritus paremaks muuta`,
sharingCards: `Jagamiskaardid`,
published: `Avaldatud`,
alreadyHaveAccount: `On juba konto?`,
notAlreadyHaveAccount: `Kas teil pole veel kontot?`,
startPractice: `Alustage harjutamist`,
selectQuizTypes: `Valige viktoriini tüübid`,
correct: `Õige`,
incorrect: `Ebakorrektne`,
yes: `Jah`,
no: `Mitte`,
levelSilver: `Hõbe tase __`,
levelGold: `Kuldne tase __`,
levelPlatinum: `Plaatina tase __`,
levelDiamond: `Teemantitase __`,
levelJade: `Jade tase __`,
reviewsLeftGoal: `__ Ülevaated igapäevase eesmärgi saavutamiseks`,
dailyGoalAchieved: `Igapäevane eesmärk on saavutatud`,
share: `Osa`,
rateApp: `Hindade rakendus`,
allStats: `Kõik statistika`,
reviewTimeError: `Ajatu pärast vea`,
reviewTimeCorrect: `Ajatu pärast õiget`,
pronounceTermAfterReview: `Hääldake tähtaeg pärast ülevaatamist`,
pronounceDefinitionAfterReview: `Hääldage määratlus pärast ülevaatamist`,
practice: `Praktika`,
notificationsScheduledInfo: `__ Teated on kavandatud, saate rakenduse kohe sulgeda`,
wellDone: `Hästi tehtud`,
keepItUp: `Jätka samas vaimus`,
youRock: `Sa rokid`,
niceOne: `Kena`,
lnSelect: `Vali keel`,
sampleData: `Ülevaateid pole, näidisandmete kuvamine`,
reviewFreq: `Ülevaatussagedus`,
selectPractice: `Praktika: valige`,
spellPractice: `Praktika: loits`,
connectPractice: `Praktika: ühendage`,
languages: `Keeled`,
languagesPairs: `Keelepaarid`,
shareArrow: `Jagage komplekt sõprade, õpilaste või kogu kogukonnaga`,
cardsPerRound: `Kaardid / ring`,
showAll: `Näita kõike`,
supportedLangsVary: `Toetatud keeled on erinevad`,
practiceWithoutSave: `Praktikat pole päästetud`,
practiceWithoutSaveBody: `Te pole seda Studyset oma kollektsiooni lisanud, kas soovite selle nüüd oma õppekäigu säästmiseks lisada?`,
saveSetNow: `Salvestage kaardid teile kollektsiooni`,
continueWithoutSaveSave: `Alustage harjutamist ilma säästmiseta`,
createdBy: `Loodud`,
setSavedToYourCollection: `Teie kollektsiooni salvestatud õppekomplekt`,
accountBackupDisclaimer: `Pange tähele, et seda kontot saab kasutada ainult teistega jagamiseks ja seda ei saa kasutada oma StudySets või Flash -kaartide varundamiseks ega sünkroonimiseks. Kõigi andmete sünkroonimiseks ja varundamiseks kasutage Dropboxi sünkroonimist`,
syncEnabled: `Sünkroonimine võimaldas, tõmmates teie poolelioleva sisu`,
searchAllSets: `Otsingukomplektid teistelt kasutajatelt`,
anyLanguage: `Mis tahes keel`,
trendingIn: `Trendikas`,
manualBackups: `Käsitsi varukoopia`,
manualBackupCreate: `Looge käsitsi varundamine`,
confirmManualImport: `Kas olete kindel, et soovite kõik praegused andmed selle varukoopiaga asendada? Seda soovitatakse ainult uutes seadmetes ilma andmeteta`,
importFromManualBackup: `Import varukoopiast`,
imgOfflineSets: `Auto-alla laadige pilte võrguühenduseta õppimiseks`,
unsupportedDeviceCache: `See funktsioon on saadaval ainult iOS või Androidi rakendusest`,
shareChanges: `Jaga __ muudatusi`,
publiclySearchable: `Kasutajate poolt otsitav`,
description: `Kirjeldus`,
restoreFromDropboxBackup: `Taastage Dropboxi varukoopiast`,
imageCacheStudysetSub: `[Ainult iOS & Android] Laadige võrguühenduseta õppimiseks alla pilt`,
keywordsOrLangNeeded: `Peate sisestama mõned märksõnad või ühe keele`,
dropboxAlreadyLinked: `Dropboxi konto on juba lingitud`,
noSetUpdateAccess: `Teil pole juurdepääsu selle uuringu komplekti muutmiseks.`,
confirmSetOwnerLogin: `Kui olete kindel, et olete omanik, proovige uuesti sisse logida oma kontole.`,
uninitedRestriction: `Oma edusammude säästmiseks peate kõigepealt lisama selle Studyset oma kollektsiooni`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Salvestuse konsolideerimine ei suutnud`,
consolidateStorageDone: `Salvestuse konsolideerumine, palun laske Dropboxil enne uude seadme sisselogimist lõpetada vanade failide eemaldamine.`,
consolidatingStorage: `Salvestuse konsolideerimine ...`,
deleteAccount: `Konto kustutama`,
consolidateStorageDescription: `See toiming kinnitab teie varukoopiafaile, nii et uute seadmete seadistamine on kiirem`,
consolidatingStorageConfirm: `Veenduge, et kõik teie muudatused on juba sünkroonimise lõpetanud, ärge sünkroonige muid seadmeid, kui see protsess toimub. Kas sa tahad jätkata?`,
consolidateStorage: `Salvestust konsolideerida`,


}